import React from "react";
import moment from "moment";
import { ENV_VERIFIED_TRAINER, isBrandActive } from "src/config/environment.config";
import type { TeachrCourseSessionInfo } from "../../../Repositories/PunctualCourseRepository";
import { studentFullName } from "../format";
import { vocab } from "../vocabulary";
import { useDeclarationV2 } from "../DeclarationV2Context";
import UpcomingCoursesPanel from "../components/UpcomingCoursesPanel";
import StepsRail, { RailStep } from "./StepsRail";
import StudentMonthPanel from "./StudentMonthPanel";

interface Props {
    current: number;
    /** Résumé de l'étape Planning quand elle est terminée. */
    planningDetail?: React.ReactNode;
    /** Résumé de l'étape Tarif quand elle est terminée. */
    pricingDetail?: React.ReactNode;
    month?: moment.Moment;
    clientSessions?: TeachrCourseSessionInfo[];
    clientSessionsLoading?: boolean;
    /** Encarts supplémentaires sous le rail (avertissement quota, etc.). */
    extra?: React.ReactNode;
    /** Masque l'encart du mois (remplacé par `extra`). */
    hideMonthPanel?: boolean;
}

/** Colonne de droite des étapes 2 à 4 : rail, encart du mois, cours déjà prévus. */
const PlanningAside = ({ current, planningDetail, pricingDetail, month, clientSessions, clientSessionsLoading, extra, hideMonthPanel = false }: Props) => {
    const { teachr, state, goTo } = useDeclarationV2();
    const isVt = isBrandActive(ENV_VERIFIED_TRAINER);
    const student = state.student;
    const clientLabel = vocab.client().charAt(0).toUpperCase() + vocab.client().slice(1);
    const steps: RailStep[] = [
        { number: 1, label: clientLabel, detail: student ? studentFullName(student.child) : undefined, onEdit: () => goTo("student") },
        { number: 2, label: "Planning", detail: planningDetail, onEdit: () => goTo("planning") },
        { number: 3, label: `Tarif ${!isVt && `& ${vocab.subjectLabel()}`}`, detail: pricingDetail, onEdit: () => goTo("pricing") },
        { number: 4, label: "Récapitulatif" },
    ];
    return (
        <>
            <StepsRail steps={steps} current={current} />
            {extra}
            {student && !hideMonthPanel && <StudentMonthPanel child={student.child} teachr={teachr} />}
            {student && month && clientSessions && (
                <UpcomingCoursesPanel child={student.child} month={month} sessions={clientSessions} loading={clientSessionsLoading} />
            )}
        </>
    );
};

export default PlanningAside;
